// utils/AppHelpers.js

import React, { useState, useEffect } from 'react';

// ... (Keep existing Icons: PaperclipIcon, CartIcon, CloseIcon, MicIcon, StopIcon, DraftIcon) ...
export const PaperclipIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>
);
export const CartIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
);
export const CloseIcon = (props) => (
     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
);
export const MicIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line></svg>
);
export const StopIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#D72C0D" stroke="#D72C0D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><rect x="6" y="6" width="12" height="12"></rect></svg>
);
export const DraftIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
);

// --- HOOKS ---
export const useMediaQuery = (maxWidth) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= maxWidth);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= maxWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [maxWidth]);
    return isMobile;
};

// --- PRODUCT GETTERS ---
export const getProductName = (product) => product.productName || product.product_name || product.Name || 'Unnamed Product';
export const getProductPrice = (product) => product.sellingPrice || product.price || 0;
export const getProductDescription = (product) => product.description || null;
export const getProductCategory = (product) => product.category || null;
export const getProductUnit = (product) => product.unitCount || product.Unit || null;

// New Helper for Sales Stats
export const getProductSalesStats = (product) => {
    // Checks if totalUnitsSold exists and is greater than 0
    if (product.totalUnitsSold && product.totalUnitsSold > 0) {
        return product.totalUnitsSold;
    }
    return null;
};

export const getProductWeight = (product) => {
    const weight = product.productWeight || product.Size || null;
    const weightType = product.productWeightType || product.Weight || null;
    if (weight && weightType) return `${weight} ${weightType}`;
    if (weight) return `${weight}`;
    return null;
};

export const getProductImageUrl = (product) => {
    if (product && product.image && typeof product.image === 'string' && product.image.trim() !== '') {
        return product.image;
    }
    return product ? `https://via.placeholder.com/300x300.png?text=${product.sku || 'No SKU'}` : `https://via.placeholder.com/300x300.png?text=No+Img`;
}